/**
 * 공연장 관련 Write 작업 목차
 * 
 * - saveVenueInfo() - 공연장 정보 저장/업데이트
 * - saveVenueMapLink() - 공연장 지도 링크 저장
 * - saveVenueContact() - 공연장 연락처 저장
 * - saveVenueRegion() - 공연장 지역 저장
 * - renameVenue() - 공연장명 변경
 * - setVenueImage() - 공연장 이미지 설정
 * - removeVenueImage() - 공연장 이미지 삭제
 */

import apiClient from "@/utils/api";

/**
 * 공연장 정보 저장/업데이트
 * @param {string} venueName - 공연장 이름
 * @param {Object} venueData - 공연장 데이터
 * @returns {Promise<void>}
 */
export async function saveVenueInfo(venueName, venueData) {
  try {
    await apiClient.post("/api/venue", {
      name: venueName,
      ...venueData,
    });
  } catch (error) {
    console.error("공연장 정보 저장 오류:", error);
    throw error;
  }
}

/**
 * 공연장 지도 링크 저장
 * @param {string} venueName - 공연장 이름
 * @param {string} mapLink - 지도 링크
 * @returns {Promise<void>}
 */
export async function saveVenueMapLink(venueName, mapLink) {
  try {
    await apiClient.put(`/api/venue/${encodeURIComponent(venueName)}`, {
      mapLink,
    });
  } catch (error) {
    console.error("공연장 지도 링크 저장 오류:", error);
    throw error;
  }
}

/**
 * 공연장 연락처 저장
 * @param {string} venueName - 공연장 이름
 * @param {string} contact - 연락처
 * @returns {Promise<void>}
 */
export async function saveVenueContact(venueName, contact) {
  try {
    await apiClient.put(`/api/venue/${encodeURIComponent(venueName)}`, {
      contact,
    });
  } catch (error) {
    console.error("공연장 연락처 저장 오류:", error);
    throw error;
  }
}

/**
 * 공연장 지역 저장
 * @param {string} venueName - 공연장 이름
 * @param {string} region - 지역
 * @returns {Promise<void>}
 */
export async function saveVenueRegion(venueName, region) {
  try {
    await apiClient.put(`/api/venue/${encodeURIComponent(venueName)}`, {
      region,
    });
  } catch (error) {
    console.error("공연장 지역 저장 오류:", error);
    throw error;
  }
}

/**
 * 공연장명 변경
 * @param {string} oldName - 기존 공연장 이름
 * @param {string} newName - 새 공연장 이름
 * @returns {Promise<void>}
 */
export async function renameVenue(oldName, newName) {
  try {
    await apiClient.put(`/api/venue/${encodeURIComponent(oldName)}/rename`, {
      newName,
    });
  } catch (error) {
    console.error("공연장명 변경 오류:", error);
    throw error;
  }
}

/**
 * 공연장 이미지 설정
 * @param {string} venueName - 공연장 이름
 * @param {string} fileName - 이미지 파일명
 * @returns {Promise<void>}
 */
export async function setVenueImage(venueName, fileName) {
  try {
    await apiClient.post(`/api/venue/${encodeURIComponent(venueName)}/image`, {
      fileName,
    });
  } catch (error) {
    console.error("공연장 이미지 설정 오류:", error);
    throw error;
  }
}

/**
 * 공연장 이미지 삭제
 * @param {string} venueName - 공연장 이름
 * @returns {Promise<void>}
 */
export async function removeVenueImage(venueName) {
  try {
    await apiClient.delete(`/api/venue/${encodeURIComponent(venueName)}/image`);
  } catch (error) {
    console.error("공연장 이미지 삭제 오류:", error);
    throw error;
  }
}
